import api from "../../config/axios";
import {
    SIGNUP_EMAIL,
    SIGNUP_GOOGLE,
    CREATE_PASSWORD,
    LOGIN_USER,
    FORGOT_PASSWORD,
    PASSWORD_RESET_SUCCESS,
    LOGIN_SUCCESS,
    LOGOUT_USER,
    LOGOUT_USER_SUCCESS,
    API_ERROR,
    PASSWORD_SET_SUCCESS,
    NEW_PAGE,
} from "../auth";

export const signupWithEmail = (email, history) => async (dispatch) => {
    localStorage.setItem("token", "");
    dispatch({
        type: SIGNUP_EMAIL,
    });
    const response = await api
        .post("api/users/signup/email/", { email, role: "student" })
        .then((response) => {
            dispatch({
                type: SIGNUP_EMAIL,
                payload: email,
            });
            if (response.status === 200 && response.data.success === "true") {
                history.push("/verification");
            } else {
                dispatch({
                    type: API_ERROR,
                    payload: response.data.message,
                });
            }
        })
        .catch((err) => {
            if (err.response) {
                dispatch({
                    type: API_ERROR,
                    payload: err.response.data.message,
                });
            } else {
                dispatch({
                    type: API_ERROR,
                    payload: "Unable to reach to Servers",
                });
            }
        });
};
export const newPage = () => (dispatch) => {
    dispatch({
        type: NEW_PAGE,
    });
};

export const ResetPassword = (
    password,
    confirmpassword,
    token,
    history
) => async (dispatch) => {
    dispatch({
        type: PASSWORD_RESET_SUCCESS,
    });

    try {
        const response = await api.post(
            "api/users/password/reset/check_password/",
            {
                password: password,
                confirmPassword: confirmpassword,
                token: token,
                role: "student",
            }
        );
        if (response.status === 200) {
            if (response.data.success) {
                localStorage.setItem("token", response.data.authToken);
                history.push("/dashboard");
            } else {
                dispatch({
                    type: API_ERROR,
                });
            }
            // history.push('/aboutyourself');
        } else {
            dispatch({
                type: API_ERROR,
            });
        }
    } catch {
        dispatch({
            type: API_ERROR,
        });
    }
};
export const forgotpassword = (email, history) => async (dispatch) => {
    localStorage.setItem("token", "");
    dispatch({
        type: FORGOT_PASSWORD,
    });
    const response = await api
        .post("api/users/password/reset/", { email, role: "student" })
        .then((response) => {
            dispatch({
                type: FORGOT_PASSWORD,
                payload: email,
            });
            if (response.status === 200 && response.data.success === "true") {
                history.push("/passwordreset");
            } else {
                dispatch({
                    type: API_ERROR,
                    payload: response.data.message,
                });
            }
        })
        .catch((err) => {
            if (err.response) {
                dispatch({
                    type: API_ERROR,
                    payload: err.response.data.message,
                });
            } else {
                dispatch({
                    type: API_ERROR,
                    payload: "Unable to reach to Servers",
                });
            }
        });
};
export const setpassword = (
    password,
    confirmpassword,
    token,
    history
) => async (dispatch) => {
    dispatch({
        type: PASSWORD_SET_SUCCESS,
    });

    try {
        const response = await api.post("api/users/signup/email/check_password/", {
            password: password,
            confirmPassword: confirmpassword,
            token: token,
            role: "student",
        });
        if (response.status === 200) {
            if (response.data.success) {
                localStorage.setItem("token", response.data.authToken);
                history.push("/studentOnboarding");
            } else {
                dispatch({
                    type: API_ERROR,
                    payload:response.data.reason || response.data.message
                });
            }
            // history.push('/aboutyourself');
        } else {
            dispatch({
                type: API_ERROR,
                payload:response.data.reason || response.data.message
            });
        }
    } catch(error) {
        dispatch({
            type: API_ERROR,
            payload:error.data.reason || error.data.message
        });
    }
};

export const signupWithGoogle = (idToken, history) => async (dispatch) => {
    dispatch({
        type: SIGNUP_GOOGLE,
    });

    const response = await api
        .post("api/users/signup/google/", {
            idToken,
            role: "student",
        })
        .then((res) => {
            if (!res.data.success) {
                dispatch({
                    type: API_ERROR,
                    payload: response.data.message,
                });
                return;
            }
            const token = res.data.authToken;
            localStorage.setItem("token", token);
            history.push("/studentOnboarding");
        })
        .catch((err) => {
            if (err.response) {
                dispatch({
                    type: API_ERROR,
                    payload: err.response.data.message,
                });
            } else if (err.request) {
                // Request was made but no response
                dispatch({
                    type: API_ERROR,
                    payload: "Unable to reach to servers",
                });
            } else {
                dispatch({
                    type: API_ERROR,
                    payload: "Unable to reach to servers",
                });
            }
        });
};

export const signupwithLinkedIn = (idToken, history) => async (dispatch) => {
    dispatch({
        type: SIGNUP_GOOGLE,
    });

    const response = await api
        .get(`api/linkedin/?code=${idToken}&role=student`)
        .then((res) => {
            if (!res.data.success) {
                dispatch({
                    type: API_ERROR,
                    payload: response.data.message,
                });
                return;
            }
            const token = res.data.authToken;
            localStorage.setItem("token", token);
            history.push("/studentOnboarding");
        })
        .catch((err) => {
            if (err.response) {
                dispatch({
                    type: API_ERROR,
                    payload: err.response.message,
                });
            } else if (err.request) {
                // Request was made but no response
                dispatch({
                    type: API_ERROR,
                    payload: "Unable to reach to servers",
                });
            } else {
                dispatch({
                    type: API_ERROR,
                    payload: "Unable to reach to servers",
                });
            }
        });
};

export const loginwithGoogle = (idToken, history) => async (dispatch) => {
    dispatch({
        type: SIGNUP_GOOGLE,
    });
    const response = await api
        .post("api/users/login/google/", {
            idToken,
            role: "student",
        })
        .then((res) => {
            if (!res.data.success) {
                dispatch({
                    type: API_ERROR,
                    payload: response.data.message,
                });
                return;
            }
            const token = res.data.authToken;
            localStorage.setItem("token", token);
            localStorage.setItem('token', res.data.authToken);
            if (res.data.is_profile_created) {
                history.push("/studentDashboard")
            }
            else {
                history.push('/studentOnboarding')
            }
        })
        .catch((err) => {
            if (err.response) {
                if (err.response.status === 404) {
                    dispatch({
                        type: API_ERROR,
                    });
                } else {
                    dispatch({
                        type: API_ERROR,
                        payload: err.response.data.message,
                    });
                }
            } else if (err.request) {
                dispatch({
                    type: API_ERROR,
                });
                // Request was made but no response
            } else {
                dispatch({
                    type: API_ERROR,
                });
            }
        });
};

export const loginwithLinkedin = (idToken, history) => async (dispatch) => {
    dispatch({
        type: SIGNUP_GOOGLE,
    });
    const response = await api
        .get(`api/linkedin/?code=${idToken}&role=student`)
        .then((res) => {
            if (!res.data.success) {
                dispatch({
                    type: API_ERROR,
                    payload: response.data.message,
                });
                return;
            }
            const token = res.data.authToken;
            localStorage.setItem("token", token);
            localStorage.setItem('token', res.data.authToken);
            if (res.data.is_profile_created) {
                history.push("/studentDashboard")
            }
            else {
                history.push('/studentOnboarding')
            }
        })
        .catch((err) => {
            if (err.response) {
                if (err.response.status === 404) {
                    dispatch({
                        type: API_ERROR,
                    });
                } else {
                    dispatch({
                        type: API_ERROR,
                    });
                }
            } else if (err.request) {
                dispatch({
                    type: API_ERROR,
                });
                // Request was made but no response
            } else {
                dispatch({
                    type: API_ERROR,
                });
            }
        });
};

export const loginUser = (email, password, history) => async (dispatch) => {
    dispatch({
        type: LOGIN_USER,
    });
 
    const response = api
        .post(
            "api/users/login/email",
            {
                email: email,
                password: password,
                role: "student",
            },
            {
                headers: {
                    "content-type": "application/json",
                    "Cache-Control": "no-cache",
                },
            }
        )
        .then((res) => {
            if (res.status === 200 && res.data.success === true) {
                dispatch({
                    type: LOGIN_SUCCESS,
                });
                localStorage.setItem("token", res.data.authToken);
                localStorage.setItem('token', res.data.authToken);
                if (res.data.is_profile_created) {
                    history.push("/studentDashboard")
                }
                else {
                    history.push('/studentOnboarding')
                }

            } else {
                dispatch({
                    type: API_ERROR,
                    payload: res.data.message,
                });
            }
        })
        .catch((err) => {
            dispatch({
                type: API_ERROR,
            });
            if (err.response) {
                if (err.response.status === 404) {
                    console.log("Error: Page Not Found");
                } else {
                    console.log(err.response.data.reason);
                }
            } else if (err.request) {
                // Request was made but no response
                console.log(err.request);
            } else {
                console.log(err.message);
            }
        });

    //Add async action
};

export const loginSuccess = (user) => {
    return {
        type: LOGIN_SUCCESS,
        payload: user,
    };
};

export const logoutUser = (history) => {
    return {
        type: LOGOUT_USER,
        payload: { history },
    };
};

export const logoutUserSuccess = () => {
    return {
        type: LOGOUT_USER_SUCCESS,
        payload: {},
    };
};

export const apiError = (error) => {
    return {
        type: API_ERROR,
        payload: error,
    };
};
